/**
 * 加解密配置管理
 * 从环境变量中读取配置
 */

/**
 * 加解密配置（使用getter确保每次读取最新值）
 */
const encryptConfig = {
  get enabled() {
    // 从环境变量读取，明确检查 'true' 或 'false'
    const envValue = process.env.VUE_APP_ENCRYPT_ENABLED
    if (envValue === 'true') {
      return true
    } else if (envValue === 'false') {
      return false
    }
    // 环境变量未设置或不是明确的 true/false，默认返回 false
    return false
  },

  get cryptoType() {
    return process.env.VUE_APP_ENCRYPT_TYPE || undefined
  },

  get encryptKey() {
    return process.env.VUE_APP_ENCRYPT_KEY || undefined
  },

  get decryptKey() {
    return process.env.VUE_APP_ENCRYPT_DECRYPT_KEY || undefined
  },

  get adminRsaPublicKey() {
    return process.env.VUE_APP_ENCRYPT_ADMIN_RSA_PUBLIC_KEY || undefined
  },

  get excludes() {
    return process.env.VUE_APP_ENCRYPT_EXCLUDES || undefined
  }
}

/**
 * 检查路径是否需要加密
 * @param {String} url - 请求URL
 * @returns {Boolean} 是否需要加密
 */
export function shouldEncrypt(url) {
  // 每次都重新读取配置，确保获取最新值
  const enabled = encryptConfig.enabled
  if (!enabled) {
    return false
  }

  // 检查排除路径
  const excludes = encryptConfig.excludes
  if (excludes) {
    const excludeList = excludes.split(',')
    for (const exclude of excludeList) {
      if (url.includes(exclude.trim())) {
        return false
      }
    }
  }

  return true
}

/**
 * 根据URL获取对应的RSA公钥
 * @param {String} url - 请求URL
 * @returns {String} RSA公钥
 */
export function getRsaPublicKeyByUrl(url) {
  if (!url) {
    return encryptConfig.adminRsaPublicKey
  }

  // APP服务路径
  if (url.includes('/app-api') || url.startsWith('/app-api')) {
    // 如果有APP公钥配置，返回APP公钥，否则返回Admin公钥
    return process.env.VUE_APP_ENCRYPT_APP_RSA_PUBLIC_KEY || encryptConfig.adminRsaPublicKey
  }

  // Admin服务路径（默认）
  return encryptConfig.adminRsaPublicKey
}

/**
 * 获取加密配置（每次都重新读取最新值）
 */
export function getEncryptConfig() {
  return {
    enabled: encryptConfig.enabled,
    cryptoType: encryptConfig.cryptoType,
    encryptKey: encryptConfig.encryptKey,
    decryptKey: encryptConfig.decryptKey,
    adminRsaPublicKey: encryptConfig.adminRsaPublicKey,
    excludes: encryptConfig.excludes
  }
}

export default encryptConfig

